import {REHYDRATE} from 'redux-persist'
import types from "./types";

const initialState = {
  visible: true,
  isBasicFilterActive: true,
  loading: true,
  useExtent: true,
  geometry: null,
  hasSpatialFilter: false,
  spatialFilterID: null,
  gacc: null,
  fireCauses: [],
  discoveryDateMax: null,
  discoveryDateMin: new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
  outDateMax: null,
  outDateMin: null,
  modifiedDateMax: null,
  modifiedDateMin: null,
  fireAcresMax: null,
  fireAcresMin: null,
  originWhereClause: null,
  structuresDestroyed: null,
  uniqueness: null,
  fatalities: null,
  otherStructuresDestroyed: null,
  residencesThreatened: null,
  otherStructuresThreatened: null,
  certified: null,
  perimeterMapMethod: null,
  perimeterFeatureStatus: null,
  perimeterFeatureAccess: null,
  strategies: [],
  irwinRelationships: [],
  dataSources: ['1'],
  multiRootOnly: false,
  categories: ['WF'],
  reportSearchTerms: null,
  landownerCategories: [],
  incidentJurisdictionalAgency: null,
  state: null,
  county: null,
  capabilityRequests: null,
  pooProtectingUnit: null,
  pooProtectingAgency: null,
  jurisdictionalUnit: null,
  dispatchCenterID: null,
  uniqueFireIds: [],
  activeDrawTool: null,
  modifiedBySystem: null,
  createdBySystem: null,
  narrativeFilter: null,
  narrativeFilterState: null,
  utcOffset: null,
  perimeterAcreageLandowner: null,
  perimeterAcreageOperator: null,
  perimeterAcreageNumber: 0,
  //perimeterAcreageIds: [],
  //shouldFilterOnPerimeterAcreageIds: false
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      if(action.payload && action.payload.filter){
        action.payload.filter.loading = true;
        action.payload.filter.uniqueFireIds = [];
        state = {
          ...state,
          ...action.payload.filter
        };
      }
      break;
      case types.MANUAL_REHYDRATE_FILTER:
        if(action.payload && action.payload.filter){
          action.payload.filter.loading = true;
          action.payload.filter.uniqueFireIds = [];
          state = {
            ...state,
            ...action.payload.filter
          };
        }
        break;
    case types.RESET_FILTERS:
    state = {
      ...state,
      visible: true,
      geometry: null,
      hasSpatialFilter: false,
      spatialFilterID: null,
      gacc: null,
      isBasicFilterActive: true,
      fireCauses: [],
      discoveryDateMax: null,
      discoveryDateMin: new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0),
      outDateMax: null,
      outDateMin: null,
      modifiedDateMax: null,
      modifiedDateMin: null,
      fireAcresMax: null,
      fireAcresMin: null,
      originWhereClause: null,
      structuresDestroyed: null,
      injuries: null,
      fatalities: null,
      otherStructuresDestroyed: null,
      residencesThreatened: null,
      otherStructuresThreatened: null,
      certified: null,
      perimeterMapMethod: null,
      perimeterFeatureStatus: null,
      perimeterFeatureAccess: null,
      strategies: [],
      irwinRelationships:[],
      dataSources:[],
      multiRootOnly: false,
      categories: ['WF'],
      reportSearchTerms: null,
      landownerCategories: [],
      incidentJurisdictionalAgency: null,
      state: null,
      county: null,
      capabilityRequests: null,
      pooProtectingUnit: null,
      pooProtectingAgency: null,
      jurisdictionalUnit: null,
      dispatchCenterID: null,
      uniqueFireIds: [],
      activeDrawTool: null,
      modifiedBySystem: null,
      createdBySystem: null,
      narrativeFilter: null,
      narrativeFilterState: null,
      utcOffset: null,
      perimeterAcreageLandowner: null,
      perimeterAcreageOperator: null,
      perimeterAcreageNumber: null
      //perimeterAcreageIds: [],
      //shouldFilterOnPerimeterAcreageIds: false
    };
    break;

    case types.SET_FILTER_LOADING:
      state = {
        ...state,
        loading: action.payload.loading
      };
      break;
    case types.SET_FILTER_VISIBLE:
      state = {
        ...state,
        visible: action.payload.visible
      };
      break;
      case types.SET_BASIC_FILTER_ACTIVE:
        state = {
          ...state,
          isBasicFilterActive: action.payload.isBasicFilterActive
        };
        break;
    case types.SET_NARRATIVE_FILTER:
      state = {
        ...state,
        narrativeFilter: action.payload.narrativeFilter,
        narrativeFilterState: action.payload.narrativeFilterState
      };
      break;

    case types.SET_FILTER_GEOMETRY:
      state = {
        ...state,
        geometry: action.payload.geometry
      };
      break;

      case types.SET_HAS_SPATIAL_FILTER:
      state = {
        ...state,
        hasSpatialFilter: action.payload.hasSpatialFilter
      };
      break;

      case types.SET_SPATIAL_FILTER_ID:
        state = {
          ...state,
          spatialFilterID: action.payload.spatialFilterID
        };
        break;

      case types.CLEAR_PERIMETER_ACREAGE:
        state = {
          ...state,
          perimeterAcreageLandowner: null,
          setPerimeterAcreageOperator: null,
          perimeterAcreageNumber: null
        };
        break;
        
      case types.SET_PERIMETER_ACREAGE_LANDOWNER:
      state = {
        ...state,
        perimeterAcreageLandowner: action.payload.perimeterAcreageLandowner
      };
      break;

      case types.SET_PERIMETER_ACREAGE_OPERATOR:
        state = {
          ...state,
          perimeterAcreageOperator: action.payload.perimeterAcreageOperator
        };
        break;

        case types.SET_PERIMETER_ACREAGE_NUMBER:
          state = {
            ...state,
            perimeterAcreageNumber: action.payload.perimeterAcreageNumber
          };
          break;

      case types.ADD_INITIAL_STRATEGY:
        state = {
          ...state,
          strategies: [...state.strategies, action.payload.strategy]
        };
        break;

      case types.REMOVE_INITIAL_STRATEGY:
        state = {
          ...state,
          strategies: [...state.strategies.filter(strategy => strategy !== action.payload.strategy)]
        };
        break;

      case types.CLEAR_INITIAL_STRATEGY:
        state = {
          ...state,
          strategies: []
        };
        break;

        case types.ADD_IRWIN_RELATIONSHIP:
        state = {
          ...state,
          irwinRelationships: [...state.irwinRelationships, action.payload.irwinRelationship]
        };
        break;

      case types.REMOVE_IRWIN_RELATIONSHIP:
        state = {
          ...state,
          irwinRelationships: [...state.irwinRelationships.filter(irwinRelationship => irwinRelationship !== action.payload.irwinRelationship)]
        };
        break;

      case types.CLEAR_IRWIN_RELATIONSHIPS:
        debugger;
        state = {
          ...state,
          irwinRelationships: []
        };
        break;

        case types.ADD_DATA_SOURCE:
          state = {
            ...state,
            dataSources: [...state.dataSources, action.payload.source]
          };
          break;

          case types.SET_MULTI_ROOT:
            state = {
              ...state,
              multiRootOnly: action.payload.multiRootOnly
            };
            break;

        case types.REMOVE_DATA_SOURCE:
          state = {
            ...state,
            dataSources: [...state.dataSources.filter(source => source !== action.payload.source)]
          };
          break;

        case types.CLEAR_DATA_SOURCE:
          state = {
            ...state,
            dataSources: [],
            multiRootOnly: false
          };
          break;

        case types.ADD_LANDOWNER_CATEGORY:
          state = {
            ...state,
            landownerCategories: [...state.landownerCategories, action.payload.category]
          };
          break;

        case types.REMOVE_LANDOWNER_CATEGORY:
          state = {
            ...state,
            landownerCategories: [...state.landownerCategories.filter(category => category !== action.payload.category)]
          };
          break;

        case types.CLEAR_LANDOWNER_CATEGORY:
          state = {
            ...state,
            landownerCategories: []
          };
          break;

        case types.ADD_INITIAL_TYPE:
          state = {
            ...state,
            categories: [...state.categories, action.payload.category]
          };
          break;

        case types.REMOVE_INITIAL_TYPE:
          state = {
            ...state,
            categories: [...state.categories.filter(category => category !== action.payload.category)]
          };
          break;

        case types.CLEAR_INITIAL_TYPE:
          state = {
            ...state,
            categories: []
          };
          break;


    case types.ADD_FIRE_CAUSE:
      state = {
        ...state,
        fireCauses: [...state.fireCauses, action.payload.fireCause]
      };
      break;

    case types.REMOVE_FIRE_CAUSE:
      state = {
        ...state,
        fireCauses: [...state.fireCauses.filter(cause => cause !== action.payload.fireCause)]
      };
      break;

    case types.CLEAR_FIRE_CAUSE:
      state = {
        ...state,
        fireCauses: []
      };
      break;
      //  SET_UTC_OFFSET_FILTER,
      //CLEAR_UTC_OFFSET_FILTER 

      case types.SET_UTC_OFFSET_FILTER:
      state = {
        ...state,
        utcOffset: action.payload.utcOffset
      };
      break;

    case types.CLEAR_UTC_OFFSET_FILTER:
      state = {
        ...state,
        utcOffset: null
      };
      break;

    case types.SET_FIRE_ACRE_FILTER:
      state = {
        ...state,
        fireAcresMax: action.payload.acres.max,
        fireAcresMin: action.payload.acres.min
      };
      break;

    case types.CLEAR_FIRE_ACRE_FILTER:
      state = {
        ...state,
        fireAcresMax: null,
        fireAcresMin: null
      };
      break;

    case types.SET_FIRE_DISCOVERY_DATES:
      state = {
        ...state,
        discoveryDateMax: action.payload.discoveryDates.max,
        discoveryDateMin: action.payload.discoveryDates.min
      };
      break;

    case types.CLEAR_FIRE_DISCOVERY_DATES:
      state = {
        ...state,
        discoveryDateMax: null,
        discoveryDateMin: null
      };
      break;

    case types.SET_FIRE_OUT_DATES:
      state = {
        ...state,
        outDateMax: action.payload.outDates.max,
        outDateMin: action.payload.outDates.min
      };
      break;

    case types.CLEAR_FIRE_OUT_DATES:
      state = {
        ...state,
        outDateMax: null,
        outDateMin: null
      };
      break;

    case types.SET_MODIFIED_DATES:
      state = {
        ...state,
        modifiedDateMax: action.payload.modifiedDates.max,
        modifiedDateMin: action.payload.modifiedDates.min
      };
      break;

    case types.CLEAR_MODIFIED_DATES:
      state = {
        ...state,
        modifiedDateMax: null,
        modifiedDateMin: null
      };
      break;

    /*case types.SET_PERIMETER_ACREAGE_IDS:
      state = {
        ...state,
        perimeterAcreageIds: action.payload.perimeterAcreageIds,
        shouldFilterOnPerimeterAcreageIds: true
      };
      break; */

      case types.SET_STRUCTURES_FILTER:
        state = {
          ...state,
          structuresDestroyed: action.payload.structuresDestroyed
        };
        break;
    case types.SET_INJURIES_FILTER:
      state = {
        ...state,
        injuries: action.payload.injuries
      };
      break;

      case types.SET_UNIQUENESS_FILTER:
        state = {
          ...state,
          uniqueness: action.payload.uniqueness
        };
        break;

    case types.SET_FATALITIES_FILTER:
      state = {
        ...state,
        fatalities: action.payload.fatalities
      };
      break;

    case types.SET_PERIMETER_MAP_METHOD_FILTER:
      state = {
      ...state,
      perimeterMapMethod: action.payload.perimeterMapMethod
      };
      break;

    case types.SET_PERIMETER_FEATURE_STATUS_FILTER:
      state = {
      ...state,
      perimeterFeatureStatus: action.payload.perimeterFeatureStatus
      };
      break;

    case types.SET_PERIMETER_FEATURE_ACCESS_FILTER:
      state = {
        ...state,
        perimeterFeatureAccess: action.payload.perimeterFeatureAccess
      };
      break;

      case types.SET_OTHER_STRUCTURES_DESTROYED_FILTER:
        state = {
          ...state,
          otherStructuresDestroyed: action.payload.otherStructuresDestroyed
        };
        break;

        case types.SET_RESIDENCES_THREATENED_FILTER:
          state = {
            ...state,
            residencesThreatened: action.payload.residencesThreatened
          };
          break;

          case types.SET_OTHER_STRUCTURES_THREATENED_FILTER:
            state = {
              ...state,
              otherStructuresThreatened: action.payload.otherStructuresThreatened
            };
            break;

    case types.SET_CERTIFIED_FILTER:
      state = {
        ...state,
        certified: action.payload.certified
      };
      break;
    case types.SET_GACC_FILTER:
        state = {
          ...state,
          gacc: action.payload.gacc
        };
    break;

    case types.SET_CAPABILITY_REQUESTS_FILTER:
        state = {
          ...state,
          capabilityRequests: action.payload.capabilityRequests
        };
    break;


    case types.SET_STATE_FILTER:
        state = {
          ...state,
          state: action.payload.state,
          county: null
        };
    break;

    case types.SET_COUNTY_FILTER:
        state = {
          ...state,
          county: action.payload.county
        };
    break;

   case types.SET_MODIFIED_BY_SYSTEM_FILTER:
        state = {
          ...state,
          modifiedBySystem: action.payload.modifiedBySystem
        };
        break;

      case types.SET_CREATED_BY_SYSTEM_FILTER:
           state = {
             ...state,
              createdBySystem: action.payload.createdBySystem
          };
      break;

    case types.SET_TYPE_CATEGORY_FILTER:
          state = {
            ...state,
            category: action.payload.category
          };
          break;

    case types.SET_REPORT_SEARCH_TERMS:
      state = {
        ...state,
        reportSearchTerms: action.payload.reportSearchTerms
      };
      break;

    case types.SET_INCIDENT_JURISDICTIONAL_AGENCY:
      state = {
        ...state,
        incidentJurisdictionalAgency: action.payload.incidentJurisdictionalAgency
      };
      break;

      case types.SET_DISPATCH_CENTER_ID:
        state = {
          ...state,
          dispatchCenterID: action.payload.dispatchCenterID
        };
        break;

    case types.SET_POO_PROTECTING_UNIT:
      state = {
        ...state,
        pooProtectingUnit: action.payload.pooProtectingUnit
      };
      break;

    case types.SET_POO_PROTECTING_AGENCY:
      state = {
        ...state,
        pooProtectingAgency: action.payload.pooProtectingAgency
      };
      break;

    case types.ADD_UNIQUE_FIRE_ID:
      state = {
        ...state,
        uniqueFireIds: [...state.uniqueFireIds, action.payload.uniqueFireIdentifier]
      };
      break;

    case types.REMOVE_UNIQUE_FIRE_ID:
      state = {
        ...state,
        uniqueFireIds: [...state.uniqueFireIds.filter(id => id !== action.payload.uniqueFireIdentifier)]
      };
      break;

    case types.CLEAR_UNIQUE_FIRE_ID:
      state = {
        ...state,
        uniqueFireIds: []
      };
      break;

    case types.SET_JURISDICTIONAL_UNIT:
      state = {
        ...state,
        jurisdictionalUnit: action.payload.jurisdictionalUnit
      };
      break;

  /*  case types.SET_JURISDICTIONAL_UNIT_PARENT_UNIT:
      state = {
        ...state,
        jurisdictionalUnitParentUnit: action.payload.jurisdictionalUnitParentUnit
      };
      break; */
    case types.SET_ACTIVE_DRAW_TOOL:
      state = {
        ...state,
        activeDrawTool: action.payload.activeDrawTool
      };
      break;

    default:
      break;

  }

  return state;

}

export default filterReducer;
